import { render } from "./vendor-update.vue?vue&type=template&id=82d11bc8"
import script from "./vendor-update.vue?vue&type=script&lang=js"
export * from "./vendor-update.vue?vue&type=script&lang=js"

import exportComponent from "/home/Work/max/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__